var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileAvatar = function SvgProfileAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_Pic",
    clipPath: "url(#clip0_1834_225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79565 40.4786L10.105 33.1104C10.1796 31.3335 11.5202 29.8672 13.2833 29.6341C19.6556 28.7914 26.111 28.7914 32.4832 29.6341C34.2463 29.8672 35.5869 31.3335 35.6615 33.1104L35.9481 39.9366C41.286 35.8759 44.732 29.4562 44.732 22.2318C44.732 9.95336 34.7784 -0.000244141 22.5 -0.000244141C10.2216 -0.000244141 0.268005 9.95336 0.268005 22.2318C0.268005 29.7865 4.03623 36.4611 9.79565 40.4786ZM28.6329 17.6321C28.6329 21.0193 25.8871 23.7651 22.5 23.7651C19.1128 23.7651 16.367 21.0193 16.367 17.6321C16.367 14.245 19.1128 11.4992 22.5 11.4992C25.8871 11.4992 28.6329 14.245 28.6329 17.6321Z",
    fill: "black",
    fillOpacity: 0.35
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1834_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.464,
    height: 44.464,
    fill: "white",
    transform: "translate(0.268005 -0.000244141)"
  })))));
};
export default SvgProfileAvatar;